import { Joi, objectSchemaOf, actionCreator } from '../helpers';
import { SYSTEM_INPUT } from './topics';
import type { RequestedBy } from './sleep';
import { requestedBy } from './sleep';
import { forConsole } from '../channels';

export const WAKE = 'SYSTEM/WAKE' as const;

export interface IWakeAction {
  type: typeof WAKE;
  payload: {
    consoleId: string;
    timestamp: number;
    requestedBy: RequestedBy;
  };
}

export const wakeActionSchema = objectSchemaOf<IWakeAction>({
  type: Joi.string().valid(WAKE).required(),
  payload: objectSchemaOf<IWakeAction['payload']>({
    consoleId: Joi.string().required(),
    timestamp: Joi.number().required(),
    requestedBy: Joi.string()
      .valid(...requestedBy)
      .required(),
  }),
});

export const wake = actionCreator({
  type: WAKE,
  topic: SYSTEM_INPUT,
  schema: wakeActionSchema,
  channels: [forConsole],
});
